import { Outlet } from '@tanstack/react-router'

import Footer from '@/layouts/AuthLayout/Components/Footer.tsx'

export default function AuthPagesLayout() {
    return (
        <div className="bg-background-dark relative flex min-h-screen flex-col items-center justify-center overflow-x-hidden px-4 py-8">
            <div className="relative z-10 mx-auto mb-20 w-full max-w-160 px-4">
                <Outlet />
            </div>

            <Footer />
        </div>
    )
}
